import { PhoneNumber } from "@forwardflow/components/Campaign/PhoneNumber";

const PhoneNumberPage = () => {
  return (
    <>
      <PhoneNumber />
    </>
  );
};

export default PhoneNumberPage;
